/**
 * Request Info Modal
 * 
 * Gestisce l'apertura del modal per richiesta informazioni
 * e il popolamento dei dati del prodotto/configuratore.
 */

class RequestInfoOpener extends HTMLElement {
  constructor() {
    super();
    
    const button = this.querySelector('button');
    if (!button) return;
    
    button.addEventListener('click', (e) => {
      e.preventDefault();
      this.openModal();
    });
  }
  
  openModal() {
    const modalId = this.getAttribute('data-modal');
    const modal = document.querySelector(modalId);
    
    if (!modal) {
      console.error('Request Info Modal not found:', modalId);
      return;
    }
    
    // Popola i dati del prodotto prima di aprire il modal
    this.populateProductData(modal);
    
    // Apri il modal
    const button = this.querySelector('button');
    modal.show(button);
  }
  
  populateProductData(modal) {
    // Ottieni i dati dal data-attributes
    const productCode = this.getAttribute('data-product-code') || '';
    const productName = this.getAttribute('data-product-name') || '';
    const variantInfo = this.getAttribute('data-variant-info') || '';
    const configuratorCode = this.getAttribute('data-configurator-code') || '';
    const finishesData = this.getAttribute('data-finishes') || '';
    
    // Popola i campi nascosti
    const codeInput = modal.querySelector('.product-code-input');
    const variantInput = modal.querySelector('.variant-info-input');
    const configuratorInput = modal.querySelector('.configurator-code-input');
    
    if (codeInput && productCode) {
      codeInput.value = productCode;
    }
    
    if (variantInput && variantInfo) {
      variantInput.value = variantInfo;
    }
    
    if (configuratorInput) {
      configuratorInput.value = configuratorCode;
    }
    
    // Aggiorna la visualizzazione del codice prodotto
    // Priorità: 1) SKU configuratore, 2) Codice prodotto generico, 3) Nome prodotto
    const codeDisplay = modal.querySelector('.product-code-value');
    if (codeDisplay) {
      const displayCode = configuratorCode || productCode || productName;
      codeDisplay.textContent = displayCode;
    }
    
    // Aggiorna i bollini delle finiture
    let finishes = [];
    try {
      if (finishesData) {
        finishes = JSON.parse(finishesData);
      }
    } catch (e) {
      console.warn('Could not parse finishes data:', e);
    }
    
    // Use the helper function to update modal with finishes
    if (window.updateModalWithConfiguratorData) {
      window.updateModalWithConfiguratorData(modal, configuratorCode, finishes);
    }
  }
}

customElements.define('request-info-opener', RequestInfoOpener);

/**
 * Funzione helper per aggiornare i dati del modal dinamicamente
 * (utile per il configuratore)
 */
window.updateRequestInfoModal = function(modalId, data) {
  const modal = document.querySelector(modalId);
  if (!modal) return;
  
  if (data.productCode) {
    const codeInput = modal.querySelector('.product-code-input');
    const codeDisplay = modal.querySelector('.product-code-value');
    if (codeInput) codeInput.value = data.productCode;
    if (codeDisplay) codeDisplay.textContent = data.productCode;
  }
  
  if (data.variantInfo) {
    const variantInput = modal.querySelector('.variant-info-input');
    const variantDisplay = modal.querySelector('.request-info-modal__product-variant');
    const variantValue = modal.querySelector('.variant-info-value');
    
    if (variantInput) variantInput.value = data.variantInfo;
    if (variantDisplay && variantValue) {
      variantValue.textContent = data.variantInfo;
      variantDisplay.style.display = 'block';
    }
  }
  
  if (data.configuratorCode) {
    const configuratorInput = modal.querySelector('.configurator-code-input');
    const codeDisplay = modal.querySelector('.product-code-value');
    if (configuratorInput) configuratorInput.value = data.configuratorCode;
    if (codeDisplay) codeDisplay.textContent = data.configuratorCode;
  }
};

/**
 * Integrazione con il configuratore
 * Ascolta eventi dal configuratore per aggiornare i dati
 */
document.addEventListener('DOMContentLoaded', function() {
  // Ascolta cambiamenti dalla selezione varianti
  document.addEventListener('variant:change', function(event) {
    const variant = event.detail?.variant;
    if (!variant) return;
    
    // Trova tutti gli opener nella pagina e aggiorna i loro dati
    document.querySelectorAll('request-info-opener').forEach(opener => {
      if (variant.title && variant.title !== 'Default Title') {
        opener.setAttribute('data-variant-info', variant.title);
      }
    });
  });
  
  // Ascolta aggiornamenti dal configuratore
  document.addEventListener('configurator:update', function(event) {
    const detail = event.detail;
    if (!detail) return;
    
    // Se c'è uno SKU dal configuratore (selezione completa), usalo
    // Altrimenti lascia il codice prodotto generico
    const configuratorSku = detail.sku || '';
    const finishes = detail.finishes || [];
    
    // Aggiorna gli opener con i dati del configuratore
    document.querySelectorAll('request-info-opener').forEach(opener => {
      opener.setAttribute('data-configurator-code', configuratorSku);
      opener.setAttribute('data-finishes', JSON.stringify(finishes));
    });
    
    // Aggiorna anche direttamente i modal aperti
    document.querySelectorAll('.request-info-modal').forEach(modal => {
      updateModalWithConfiguratorData(modal, configuratorSku, finishes);
    });
  });
  
  /**
   * Helper function to update modal with configurator data
   */
  function updateModalWithConfiguratorData(modal, configuratorSku, finishes) {
    const configuratorInput = modal.querySelector('.configurator-code-input');
    const codeDisplay = modal.querySelector('.product-code-value');
    const productCodeInput = modal.querySelector('.product-code-input');
    const finishesContainer = modal.querySelector('.request-info-modal__finishes');
    const finishesList = modal.querySelector('.request-info-modal__finishes-list');
    const finishesInput = modal.querySelector('.finishes-info-input');
    
    if (configuratorInput) {
      configuratorInput.value = configuratorSku;
    }
    
    // Aggiorna la visualizzazione del codice
    if (codeDisplay) {
      const fallbackCode = productCodeInput ? productCodeInput.value : '';
      codeDisplay.textContent = configuratorSku || fallbackCode;
    }
    
    // Aggiorna i bollini delle finiture
    if (finishesContainer && finishesList) {
      if (finishes && finishes.length > 0) {
        finishesList.innerHTML = finishes.map(finish => {
          const swatchStyle = finish.imageUrl 
            ? `background-image: url(${finish.imageUrl})` 
            : `background-color: ${finish.color}`;
          return `
            <div class="request-info-modal__finish-item">
              <div class="request-info-modal__finish-swatch" style="${swatchStyle}"></div>
              <span class="request-info-modal__finish-name">${finish.code} - ${finish.name}</span>
            </div>
          `;
        }).join('');
        finishesContainer.style.display = 'block';
        
        // Aggiorna anche il campo nascosto per l'email
        if (finishesInput) {
          const finishesText = finishes.map(f => `${f.code} - ${f.name}`).join(', ');
          finishesInput.value = finishesText;
        }
      } else {
        finishesList.innerHTML = '';
        finishesContainer.style.display = 'none';
        if (finishesInput) {
          finishesInput.value = '';
        }
      }
    }
  }
  
  // Expose helper for use by RequestInfoOpener
  window.updateModalWithConfiguratorData = updateModalWithConfiguratorData;
});
